import { useEffect } from 'react';
import { Sentry, isSentryEnabled } from '../sentry.js';
import { useAuth } from '../contexts/AuthContext';

/** Keeps Sentry user context in sync with the logged-in account (prefills feedback forms). */
export default function SentryUserSync() {
  const { user } = useAuth();

  useEffect(() => {
    if (!isSentryEnabled()) return;

    if (user) {
      Sentry.setUser({
        id: user.id != null ? String(user.id) : undefined,
        username: user.username || undefined,
        email: user.email || undefined,
      });
      return;
    }

    Sentry.setUser(null);
  }, [user]);

  return null;
}
